import React, { useState, useEffect } from "react";
import styles from "./AdminPassDebitMasterCollectTab.module.css";
import moment from "moment"
import { getUserProfile } from "../../../../helpers/profile_helper";
import MUIDataTable from "mui-datatables";

// import apiService from "../../../../services/api.service";

const AdminPassDebitMasterCollectTab = ({ selectedCompany, selectedAccount, apiService, onSubmit }) => {
  const [userProfile, setUserProfile] = useState({});
  const [withdraw_access, setWithdrawAccess] = useState('false')
  const [subAccounts, setSubAccounts] = useState([]);
  const [previousDebits, setPreviousDebits] = useState([]);
  const [totalBalance, setTotalBalance] = useState(0);
  const [masterAmount, setMasterAmount] = useState("");
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [numericMaster, setNumericMaster] = useState(0);
  const [currentTotalDebit, setCurrentTotalDebit] = useState(0);
  const [isValid, setIsValid] = useState(false);
  const [adjustment_ref, setAdjustmentRef] = useState('')
  const [is_confirm_disabled, setIsConfirmDisabled] = useState(false)
  const [is_authorized, setAuthroized] = useState(true)
  const [is_collect_enabled, setIsCollectEnabled] = useState(false)
  const [confirmErrors, setConfirmErrors] = useState('');
  const defaultSubAccounts = [
    { ledger_label: "CS-001", name: "RMI collect", balance: 120_000 },
    { ledger_label: "CS-002", name: "XYZ collect", balance: 80_000 },
    { ledger_label: "CS-003", name: "XYV collect", balance: 80_000 },
  ];

  const defaultPreviousDebits = [
    { id: "MD-005", amount: 350_000, timestamp: Date.now() - 2 * 3600 * 1000 },
    { id: "MD-004", amount: 400_000, timestamp: Date.now() - 26 * 3600 * 1000 },
    { id: "MD-003", amount: 300_000, timestamp: Date.now() - 50 * 3600 * 1000 },
    { id: "MD-002", amount: 380_000, timestamp: Date.now() - 74 * 3600 * 1000 },
    { id: "MD-001", amount: 420_000, timestamp: Date.now() - 98 * 3600 * 1000 },
  ];

  useEffect(() => {

    const fetchData = async () => {
      try {
        //get the linked accounts
        var user_profile = await getUserProfile();
        setUserProfile(user_profile);
        // setPreviousDebits( defaultPreviousDebits);
        var response = await apiService({
          method: "post",
          path: "/user/get_account_details",
          payload: { company: selectedCompany, account: selectedAccount },
        });

        setIsCollectEnabled(response.data.is_collect_enabled);
        var response = await apiService({ method: "post", path: "/user/widthdraw_master", payload: { company: selectedCompany, account: selectedAccount } });
        if (response.data.withdraw_master && response.data.withdraw_master == 'false') {
          var latest_adjustments = response.data.latest_adjustments;
          setWithdrawAccess('false')
          setPreviousDebits(latest_adjustments);
          if (response.data.can_view == false) {
            setAuthroized(false)
          }
          return;
        }
        var sub_escrow_arr = response.data.sub_account_balances;
        for (var i = 0; i < sub_escrow_arr.length; i++) {
          sub_escrow_arr[i].name = sub_escrow_arr[i].ledger_label;
        }
        var latest_adjustments = response.data.latest_adjustments;
        // API call to fetch sub-accounts
        // const subAccountsResponse = await fetch("/api/subAccounts");
        // if (!subAccountsResponse.ok) throw new Error("Sub-accounts fetch failed");
        // const subAccountsData = await subAccountsResponse.json();
        setWithdrawAccess('true')
        setSubAccounts(sub_escrow_arr);
        setPreviousDebits(latest_adjustments);
        setConfirmErrors('')

      } catch (error) {
        console.log("error : %o", error);
        // setSubAccounts(defaultSubAccounts);
        setPreviousDebits(defaultPreviousDebits);
      }
    };

    fetchData();
  }, [selectedCompany, selectedAccount]);

  useEffect(() => {
    // Calculate total balance

    const localNewTotalBalance = subAccounts.reduce((t, s) => t + s.balance, 0);
    setTotalBalance(localNewTotalBalance);

    // Initialize rows
    var newRows = subAccounts.map((s) => ({ ...s, debit: "" }));

    // Handle master amount and auto-calculate debits
    const m = parseFloat(masterAmount);

    if (!isNaN(m) && m > 0 && localNewTotalBalance) {
      // setRows((prev) =>
      //   prev.map((r) => ({
      //     ...r,
      //     debit: ((m * r.balance) / localNewTotalBalance).toFixed(2),
      //   }))
      // );

      var is_debits_below_balance = true;
      for (var i = 0; i < newRows.length; i++) {
        newRows[i].debit = ((m * newRows[i].balance) / localNewTotalBalance).toFixed(2);
        if (newRows[i].balance < newRows[i].debit) {
          newRows[i].error_msg = 'Debit amount exceeds balance';
          is_debits_below_balance = false;
        } else {
          newRows[i].error_msg = '';
        }
      }
    }
    setRows(newRows)
    // Calculate numeric master
    const localNewNumericMaster = parseFloat(masterAmount) || 0;
    setNumericMaster(localNewNumericMaster);

    // Calculate current total debit
    const localNewCurrentTotalDebit = newRows.reduce(
      (t, r) => t + (parseFloat(r.debit) || 0),
      0
    );
    setCurrentTotalDebit(localNewCurrentTotalDebit);

    // Validate
    setIsValid(
      parseFloat(masterAmount) > 0 &&
      Math.abs(localNewCurrentTotalDebit - localNewNumericMaster) == 0 && is_debits_below_balance
    );

  }, [subAccounts, masterAmount]);

  useEffect(() => {
    // Calculate total balance
    // Calculate numeric master
    const localNewNumericMaster = parseFloat(masterAmount) || 0;

    // Calculate current total debit
    const localNewCurrentTotalDebit = rows.reduce(
      (t, r) => t + (parseFloat(r.debit) || 0),
      0
    );
    var is_debits_below_balance = true;
    setCurrentTotalDebit(localNewCurrentTotalDebit);
    var is_debits_below_balance = true;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].balance < rows[i].debit) {
        rows[i].error_msg = 'Debit amount exceeds balance';
        is_debits_below_balance = false;
      } else {
        rows[i].error_msg = '';
      }
    }
    setIsValid(
      parseFloat(masterAmount) > 0 &&
      Math.abs(localNewCurrentTotalDebit - numericMaster) == 0 && is_debits_below_balance
    );
  }, [rows]);

  const handleDebitChange = (ledger_label, value) => {
    setRows((prev) =>
      prev.map((r) => (r.ledger_label === ledger_label ? { ...r, debit: value } : r))
    );
  };

  const handleAttemptSubmit = () => {
    var adustment_ref = moment().format('YYYYMMDDHHmmss') + '-collect-withdrawl'
    if (!isValid) return;
    setAdjustmentRef(adustment_ref)
    setOpen(true);
  };

  const handleConfirm = async () => {
    //
    setIsConfirmDisabled(true)
    const debits = rows.map(({ ledger_label, debit }) => ({
      ledger_label,
      amount: parseFloat(debit) || 0,
    }))

    try {
      // // API call to submit debit data
      // var response = await fetch("/api/submitDebits", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(payload),
      // });
      setConfirmErrors('')
      var user_profile = localStorage.getItem("user_profile");
      try {
        var response = await apiService({ method: "post", path: "/user/withdraw_from_master", payload: { company: selectedCompany, account: selectedAccount, adjustment_ref, debits } });
      } catch (error) {
        console.log("error : %o", error);
        setConfirmErrors(error?.response?.data?.data ? error?.response?.data?.data : '');
        setIsConfirmDisabled(false)
        return;
      }
      // Call onSubmit prop if provided
      // onSubmit?.(payload);
      var newSubAccounts = response.data.sub_escrow_balances;
      var newPreviousDebits = response.data.latest_adjustments
      // Reset form and close dialog
      setMasterAmount("");
      setSubAccounts(newSubAccounts.map((s) => ({ ...s, name: s.ledger_label, debit: "" })));
      setPreviousDebits(newPreviousDebits)
      setOpen(false);
      setIsConfirmDisabled(false)
    } catch (error) {
      console.error("Submit API call failed:", error);
      // Optionally, you could show an error message to the user here
    }
  };

  const columns = [{
    name: "adjustment_ref",
    label: "Adjustment Ref",
    options: {
      filter: true,
      sort: true,
    }
  }, {
    name: "amount",
    label: "Amount (₹)",
    options: {
      filter: true,
      sort: true,
    }
  }, {
    name: "timestamp",
    label: "Time & Date",
    options: {
      filter: true,
      sort: true,
    }
  }
  ];


  const options = {
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 50,100],
    selectableRows: false,
    selectableRowsHideCheckboxes:"false"
  };
  return (
    <div className={styles.container}>
      {(is_collect_enabled || withdraw_access == 'true') && (
        <div className={styles.card}>
          <div className={styles.cardHeader}>Pass Debit - Collect-Master</div>

          <div className={styles.cardContent}>
            <div className={styles.section}>
              {/* <p className={styles.sectionTitle}>Lastest Master Debits</p> */}
              <MUIDataTable
                title={"Latest Master debits"}
                data={previousDebits}
                columns={columns}
                options={options}
              />
              {/* {previousDebits.length ? (
                //replace with mui data table



                <table className={styles.table}>
                  <thead>
                    <tr className={styles.tableRow}>
                      <td className={styles.tableheading1}>Adjustment Ref</td>
                      <td className={styles.tableheading}>Amount (₹)</td>
                      <td className={styles.tableheading}>Time & Date</td>
                    </tr>
                  </thead>
                  <tbody>
                    {previousDebits.slice(0, 5).map((d) => (
                      <tr key={d.id} className={styles.tableRow}>
                        <td>{d.adjustment_ref}</td>
                        <td style={{ textAlign: "right" }}>
                          {d.amount.toLocaleString("en-IN")}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {new Date(d.timestamp).toLocaleString("en-IN", {
                            hour12: false,
                          })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className={styles.noData}>No previous debits</p>
              )} */}
            </div>
            {is_authorized == false && (
              <div className={styles.errorHeader}> Not Authorized</div>
            )}
            {withdraw_access == 'true' && (
              <><div className={styles.inputSection}>
                <label htmlFor="masterAmt" className={styles.label}>
                  Debit Collect-Master Amount
                </label>
                <input
                  id="masterAmt"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Enter amount (₹)"
                  value={masterAmount}
                  onChange={(e) => {
                    setMasterAmount(e.target.value);
                    if (e.target.value <= 0) {
                      setMasterAmount("");
                      setRows(subAccounts.map((s) => ({ ...s, debit: "" })));
                    }
                  }} />
              </div><table className={styles.table}>
                  <thead>
                    <tr className={styles.tableRow}>
                      <td className={styles.tableheading1}>Sub-Account</td>
                      <td className={styles.tableheading}>Current Balance (₹)</td>
                      <td className={styles.tableheading}>Debit Amount (₹)</td>
                      <td className={styles.tableheading}>Flags</td>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r) => (
                      <tr className={styles.tableRow}>
                        <td>{r.name}</td>
                        <td style={{ textAlign: "right" }}>
                          {r.balance.toLocaleString("en-IN")}
                          {r.cr_dr == 'Dr' ? ' Cr' : ' Dr'}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <input
                            type="number"
                            min="0"
                            step="0.01"
                            className={styles.debitInput}
                            value={r.debit}
                            onChange={(e) => handleDebitChange(r.ledger_label, e.target.value)}
                          />
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {r.error_msg && <span className={styles.errorMsg}>{r.error_msg}</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table></>
            )}
            {withdraw_access == 'true' && !isValid && numericMaster > 0 && (
              <div className={styles.error}>
                <svg
                  className={styles.errorIcon}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>

                {currentTotalDebit != numericMaster ? `Sum of debits (₹${currentTotalDebit.toLocaleString("en-IN")}) must equal master amount (₹${numericMaster.toLocaleString("en-IN")}).<br />`
                  : ''}
                {currentTotalDebit < numericMaster ? (numericMaster - currentTotalDebit).toFixed(2) + " amount is under allocated" : ''}
                {currentTotalDebit > numericMaster ? (currentTotalDebit - numericMaster).toFixed(2) + " amount is over allocated" : ''}

              </div>
            )}
          </div>
          {withdraw_access == 'true' && (
            <div className={styles.cardFooter}>
              <button disabled={!isValid} onClick={handleAttemptSubmit}>
                Submit
              </button>
            </div>
          )}
          {open && (
            <div className={styles.dialogContent}>
              <div>
                <div className={styles.heading}>Confirm Debit</div>
              </div>
              <p className={styles.dialogText}>
                You are about to debit{" "}
                <span className={styles.head33}>
                  ₹{numericMaster.toLocaleString("en-IN")}
                </span>{" "}
                from Collect-Master and debit subaccounts as below:
              </p>
              <table className={styles.table}>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id} className={styles.tableRow}>
                      <td>{r.name}</td>
                      <td style={{ textAlign: "right" }}>
                        ₹{(parseFloat(r.debit) || 0).toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className={styles.errorHeader}>{confirmErrors ? confirmErrors : ''}</div>
              <div className={styles.dialogFooter}>
                <button onClick={() => { setOpen(false); setConfirmErrors('') }}>Cancel</button>
                <button disabled={is_confirm_disabled} onClick={handleConfirm}>{is_confirm_disabled ? 'Processing....' : 'Confirm'}</button>
              </div>
            </div>
          )}
        </div>
      )}
      {is_collect_enabled == false && withdraw_access == 'false' && (
        <div className={styles.card}>
          <div className={styles.cardHeader}> Collects Not Enabled for this Account</div>
        </div>

      )}
    </div>
  );
};

export default AdminPassDebitMasterCollectTab;